import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useCallback, useMemo, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import { FormControl, InputLabel, Input } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';

import { useRouter } from 'src/routes/hooks';
import Swal from 'sweetalert2';

import Iconify from 'src/components/iconify';
import FormProvider, { RHFTextField, RHFUpload, RHFAutocomplete } from 'src/components/hook-form';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import httpCommon from 'src/http-common';

// ----------------------------------------------------------------------

export default function PendingStatus({ selectedRowID, closeModalPending }) {
  const router = useRouter();

  const getId = localStorage.getItem('QRId');
  const getHsp = localStorage.getItem('Hsp');

  const SelectedUserId = selectedRowID;
  const [UserDt, setUserDt] = useState([]);
  const [UserDtImg, setUserDtImg] = useState([]);

  const [UserInfoData, setUserInfoData] = useState([]);
  const [phnNo, setPhnNo] = useState('');
  const Username = UserInfoData.wkr_mst_requestor || '';
  const userdept = UserInfoData.wkr_mst_dept || '';

  const [NameDT, setNameDT] = useState(Username);
  const [DeptDT, setDeptDT] = useState(userdept);
  const [PhnDT, setPhnDT] = useState(phnNo);

  const ReQDes = UserDt[0]?.wkr_mst_wr_descs || '';
  const Lvl = UserDt[0]?.wkr_mst_location || '';
  const RmNo = UserDt[0]?.wkr_mst_org_locn || '';
  const SerVs = UserDt[0]?.wkr_mst_service || '';

  const [level, setLevel] = useState('');
  const [services, setServices] = useState('');
  const [location, setLocation] = useState(RmNo);
  const [reqDescription, setReqDescription] = useState(ReQDes);

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [textareaValue, setTextareaValue] = useState('');
  const [DrpData, setDrpData] = useState([]);
  const [DrpDataLeval, setDrpDataLeval] = useState([]);

  const [errorMsg, setErrorMsg] = useState('');

  // Get Api All Data
  useEffect(() => {
    const fetchUserWorkListData = async () => {
      try {
        const response = await httpCommon.get(
          `/InProgressStatus.php?id=${getId}&siteCd=${getHsp}&UserId=${SelectedUserId}`
        );
        if (response.data.status === 'SUCCESS') {
          setUserDt(response.data.data1);
          setLevel(response.data.data1[0].wkr_mst_location);
          setServices(response.data.data1[0].wkr_mst_service);
          setUserDtImg(response.data.data2);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserWorkListData(); // Call the function directly
  }, [getId, getHsp, SelectedUserId]);

  // chdck setting mode
  useEffect(() => {
    document.body.classList.remove('customNav');
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem('dataDark');
      // console.log("storedValue++", storedValue);
      if (storedValue === 'dark') {
        document.body.classList.add('custom-darkClass');
      } else {
        document.body.classList.remove('custom-darkClass');
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove('custom-darkClass');
    };
  }, []);

  useEffect(() => {
    const fetchuserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: getId,
        mst_rowID: SelectedUserId,
      };
      try {
        const response = await httpCommon.post('/getUserWRInfo.php', requestData);
        if (response.data.status === 'SUCCESS') {
          setUserInfoData(response.data.data[0]);
          setPhnNo(response.data.data[0].wkr_mst_phone);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Call the fetchuserInfo function when the component mounts.
    fetchuserInfo();
  }, [getHsp, getId, SelectedUserId]);

  useEffect(() => {
    setNameDT(Username);
    setDeptDT(userdept);
    setPhnDT(phnNo);
  }, [Username, userdept, phnNo]);

  useEffect(() => {
    const servicesDropdown = async () => {
      try {
        const response = await httpCommon.get(`/servicesDropdown.php?site_cd=H03`);
        //  console.log("SdropDown",response);
        if (response.data.status === 'SUCCESS') {
          setDrpData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    servicesDropdown();
  }, []);

  useEffect(() => {
    const LevalDropdown = async () => {
      try {
        const response = await httpCommon.get(`/levelDropdown?site_cd=H03`);
        // console.log("SdropDown3",response);
        if (response.data.status === 'SUCCESS') {
          setDrpDataLeval(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    LevalDropdown();
  }, []);

  const NewUserSchema2 = Yup.object().shape({
    // reqDescriptin: Yup.string().required('Request Description is required'),
    // location: Yup.string().required('Room No is required'),
    // service: Yup.string().required('Service is required'),
    // level: Yup.string().required('Level is required'),
    status: Yup.string(),
    isVerified: Yup.boolean(),
  });

  const NewUserSchema = Yup.object().shape({
    //  name: Yup.string().required('Name is required'),
    //  department: Yup.string().required('Department is required'),
    //  contactNo: Yup.string().required('Contact number is required'),
    //  service: Yup.string().required('Service is required'),
    //  level: Yup.string().required('Level is required'),
    //  reqDescriptin: Yup.string().required('Request Description is required'),
    //  location: Yup.string().required('Room No is required'),
    // images: Yup.mixed().nullable().required('Images is required'),
    // not required
    status: Yup.string(),
    isVerified: Yup.boolean(),
  });

  const handleNameChange = (event) => {
    setNameDT(event.target.value);
  };
  const handleDeptChange = (event) => {
    setDeptDT(event.target.value);
  };
  const handlePhnChange = (event) => {
    setPhnDT(event.target.value);
  };

  const selectedSchema =
    NameDT !== '' || DeptDT !== '' || PhnDT !== '' ? NewUserSchema2 : NewUserSchema;

  const methods = useForm({
    resolver: yupResolver(selectedSchema),
  });

  const {
    reset,
    watch,
    setValue,
    trigger,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const [errorMessage, setErrorMessage] = useState('');
  const values = watch();

  console.log('UserInfoData_Username', NameDT);
  console.log('UserInfoData_userdept', DeptDT);
  console.log('UserInfoData_phn', PhnDT);

  const onSubmit = handleSubmit(async (data) => {
    // console.log("gghh__"); level location reqDescription
    if (
      NameDT !== '' ||
      DeptDT !== '' ||
      PhnDT !== '' ||
      level !== '' ||
      location !== '' ||
      reqDescription !== ''
    ) {
      setValue('name', NameDT);
      setValue('department', DeptDT);
      setValue('contactNo', PhnDT);
      setValue('Servcs', services || SerVs);
      setValue('level', level || Lvl);
      setValue('location', location || RmNo);
      setValue('reqDes', reqDescription || ReQDes);
    }

    try {
      const requestData = {
        ...data,
        employeeID: getId,
        site_cd: getHsp,
        UserId: SelectedUserId,
      };

      const response = await httpCommon.post('/PendingStatusUpdate.php', requestData);
      if (response.data.status === 'SUCCESS') {
        closeModalPending();
        Swal.fire({
          title: 'Pending Status',
          text: 'Pending Status Data Update successfully',
          icon: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            router.push('/dashboard/user/list');
          }
        });
      } else {
        console.log('hi');
      }
    } catch (error) {
      console.error(error);
    }
  });

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      const images = watch('images') || [];

      // Check if the total number of selected files exceeds 3
      if (images.length + UserDtImg.length + acceptedFiles.length > 3) {
        setErrorMessage('You can only select up to 3 photos.');

        // Clear the error message after 3 seconds
        setTimeout(() => {
          setErrorMessage('');
        }, 6000);

        return; // Prevent adding more than 3 photos
      }
      setErrorMessage('');

      // Function to convert a file to base64
      const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      const newFiles = await Promise.all(
        acceptedFiles.map(async (file) => {
          const base64Data = await fileToBase64(file);
          return { ...file, preview: URL.createObjectURL(file), base64: base64Data };
        })
      );

      setValue('images', [...images, ...newFiles], { shouldValidate: true });
    },
    [setValue, watch, UserDtImg.length]
  );

  const handleRemoveFile = useCallback(
    (inputFile) => {
      const filtered = values.images.filter((file) => file.preview !== inputFile.preview);
      setValue('images', filtered);
    },
    [setValue, values.images]
  );

  const handleRemoveAllFiles = useCallback(() => {
    setValue('images', []);
  }, [setValue]);

  const formatDate = (dateString) => {
    const rawDate = new Date(dateString);
    const day = String(rawDate.getDate()).padStart(2, '0');
    const month = String(rawDate.getMonth() + 1).padStart(2, '0');
    const year = rawDate.getFullYear();
    const hours = String(rawDate.getHours()).padStart(2, '0');
    const minutes = String(rawDate.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };
  const handleLevelChange = (event) => {
    setLevel(event.target.value);
  };

  const handleServicesChange = (event) => {
    setServices(event.target.value);
  };

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  const handleReqDescriptionChange = (event) => {
    setReqDescription(event.target.value);
  };

  const handleDeleteButtonClick = async (image, imageIndex) => {
    const ImgRowId = image.RowID;
    const ImgMstRowId = image.mst_RowID;

    const requestDataImg = {
      site_cd: getHsp,
      ImageRowId: ImgRowId,
      ImageMstRowId: ImgMstRowId,
    };

    const response = await httpCommon.post(
      '/delete_workrequest_attachment_file.php',
      requestDataImg
    );
    if (response.data.status === 'SUCCESS') {
      const updatedUserDtImg = [...UserDtImg];
      updatedUserDtImg.splice(imageIndex, 1);
      setUserDtImg(updatedUserDtImg);
    } else {
      console.log('Image Not Delete');
    }
  };
  const handleCancelClick = async () => {
    setDialogOpen(true);
  };
  const handleConfirmCancel = async () => {
    if (textareaValue.trim() === '') {
      setErrorMsg('Please enter a reason for cancellation');
      setTimeout(() => setErrorMsg(''), 5000);
      return;
    }
    const cancelReqData = {
      site_cd: getHsp,
      employeeID: getId,
      UserRowID: SelectedUserId,
      reason: textareaValue,
    };

    // console.log("button click___",cancelReqData);
    const response = await httpCommon.post('/PendingStatusCancelReq.php', cancelReqData);

    if (response.data.status === 'SUCCESS') {
      setDialogOpen(false);
      closeModalPending();
      Swal.fire({
        title: 'Success!',
        text: 'Your request has been canceled.',
        icon: 'success',
        showConfirmButton: true,
        allowOutsideClick: false, // Disable outside click
      }).then((result) => {
        if (result.isConfirmed) {
          router.push('/dashboard/user/list');
        }
      });
    } else {
      console.log('Not Cancel');
    }
  };

  return (
    <>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Grid container spacing={4} className="RejectStatusCs">
          <Grid xs={12} md={5}>
            <Card sx={{ px: 3, pb: 5 }}>
              <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
                <Iconify
                  icon="codicon:git-pull-request-new-changes"
                  style={{ marginBottom: '-5px' }}
                />{' '}
                Requester Information
              </Typography>

              <Box display="flex" flexDirection="column" rowGap={3}>
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Employee ID</InputLabel>
                    <Input type="text" name="name" disabled defaultValue={getId || ''} />
                  </FormControl>
                </div>

                {(() => {
                  if (Username) {
                    return (
                      <div className="usrFrmFld">
                        <FormControl>
                          <InputLabel>Name</InputLabel>
                          <Input
                            type="text"
                            name="name"
                            disabled
                            defaultValue={Username || ''}
                            onChange={handleNameChange}
                          />
                        </FormControl>
                      </div>
                    );
                  }
                  return (
                    <div className="fuWdt">
                      <RHFTextField
                        id="outlined-basic"
                        name="name"
                        label="Name"
                        variant="filled"
                        onChange={handleNameChange}
                      />
                    </div>
                  );
                })()}
                <div>
                  {(() => {
                    if (userdept) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Department</InputLabel>
                            <Input
                              type="text"
                              name="department"
                              disabled
                              onChange={handleDeptChange}
                              defaultValue={userdept || ''}
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="department"
                          label="Department"
                          onChange={handleDeptChange}
                          variant="filled"
                        />
                      </div>
                    );
                  })()}
                </div>
                <div>
                  {(() => {
                    if (phnNo) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Contact No</InputLabel>
                            <Input
                              type="text"
                              name="contactNo"
                              disabled
                              onChange={handlePhnChange}
                              defaultValue={phnNo || ''}
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="contactNo"
                          label="Contact No"
                          onChange={handlePhnChange}
                          variant="filled"
                        />
                      </div>
                    );
                  })()}
                </div>
              </Box>
            </Card>
          </Grid>

          <Grid xs={12} md={7}>
            <Card sx={{ px: 3, pb: 5 }}>
              <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
                <Iconify icon="grommet-icons:workshop" style={{ marginBottom: '-5px' }} /> Work
                Request Information
              </Typography>

              <Box display="flex" flexDirection="column" rowGap={3}>
                <RHFTextField
                  name="requestDate"
                  variant="filled"
                  label="Request Date"
                  disabled
                  inputProps={{ className: 'RejinputClass' }}
                  // value={formatDate(UserDt[0]?.wkr_mst_org_date.date)}
                  value={
                    UserDt[0]?.wkr_mst_org_date.date
                      ? formatDate(UserDt[0]?.wkr_mst_org_date.date)
                      : ''
                  }
                />
                <div className="OldDropDown">
                  {(() => {
                    if (SerVs) {
                      return (
                        <div className="OldDropDown bgwhit">
                          <p>Service</p>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            value={services} // Set the selected value based on SerVs
                            onChange={handleServicesChange} // Add onChange to the select element
                          >
                            {DrpData.map((option, index) => (
                              <option key={index} value={option.mnt_svc_svc_cd}>
                                {option.mnt_svc_desc}
                              </option>
                            ))}
                          </select>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt2">
                        <div className="usrFrmFld bgwhit">
                          <p>Service</p>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            value={services} // Set the selected value based on SerVs
                            onChange={handleServicesChange} // Add onChange to the select element
                          >
                            {DrpData.map((option, index) => (
                              <option key={index} value={option.mnt_svc_svc_cd}>
                                {option.mnt_svc_desc}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    );
                  })()}
                </div>
                <div className="OldDropDown">
                  {(() => {
                    if (Lvl) {
                      return (
                        <div className="OldDropDown bgwhit">
                          <p>Level</p>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            value={level} // Set the selected value based on SerVs
                            onChange={handleLevelChange} // Add onChange to the select element
                          >
                            {DrpDataLeval.map((option, index) => (
                              <option key={index} value={option.ast_lvl_desc}>
                                {option.ast_lvl_desc}
                              </option>
                            ))}
                          </select>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt2">
                        <div className="usrFrmFld bgwhit">
                          <p>Level</p>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            value={level} // Set the selected value based on SerVs
                            onChange={handleLevelChange} // Add onChange to the select element
                          >
                            {DrpDataLeval.map((option, index) => (
                              <option key={index} value={option.ast_lvl_desc}>
                                {option.ast_lvl_desc}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    );
                  })()}
                </div>
                <div className="usrFrmFld">
                  {(() => {
                    if (RmNo) {
                      return (
                        <div className="usrFrmFld bgwhit">
                          <FormControl>
                            <InputLabel>
                              Room No/Location Description(*Please Specify Block, Level & Location
                              Description) :
                            </InputLabel>
                            <Input
                              type="text"
                              name="location"
                              defaultValue={RmNo}
                              onChange={handleLocationChange}
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <div className="usrFrmFld bgwhit">
                          <FormControl>
                            <InputLabel>
                              Room No/Location Description(*Please Specify Block, Level & Location
                              Description) :
                            </InputLabel>
                            <Input
                              type="text"
                              name="location"
                              defaultValue={RmNo}
                              onChange={handleLocationChange}
                            />
                          </FormControl>
                        </div>
                      </div>
                    );
                  })()}
                </div>
                <div className="usrFrmFld">
                  {(() => {
                    if (ReQDes) {
                      return (
                        <div className="usrFrmFld bgwhit">
                          <FormControl>
                            <InputLabel htmlFor="reqDescriptionInput">
                              Request Description
                            </InputLabel>
                            <Input
                              type="text"
                              name="reqDescriptin"
                              id="reqDescriptionInput"
                              defaultValue={ReQDes}
                              onChange={handleReqDescriptionChange}
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <div className="usrFrmFld bgwhit">
                          <FormControl>
                            <InputLabel>Request Description</InputLabel>
                            <Input
                              type="text"
                              name="reqDescriptin"
                              defaultValue={ReQDes}
                              onChange={handleReqDescriptionChange}
                            />
                          </FormControl>
                        </div>
                      </div>
                    );
                  })()}
                </div>

                <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
                  <Iconify
                    icon="material-symbols:settings-photo-camera-sharp"
                    style={{ marginBottom: '-5px' }}
                  />{' '}
                  Requested Images
                </Typography>
                <div className="pendingHvr">
                  {errorMessage && <div className="erMsg">{errorMessage}</div>}
                  {/* File upload component */}
                  <RHFUpload
                    multiple
                    thumbnail
                    name="images"
                    maxSize={3145728}
                    onDrop={handleDrop}
                    onRemove={handleRemoveFile}
                    onRemoveAll={handleRemoveAllFiles}
                    onUpload={() => console.info('ON UPLOAD')}
                  />

                  <div className="image-grid">
                    {UserDtImg.map((image, index) =>
                      image.attachment !== '' && image.attachment !== null ? (
                        <div key={index} className="image-item">
                          <div className="image-containerctm">
                            <img
                              src={image.attachment}
                              alt={`Pending ${index + 1}`}
                              className="grid-image"
                            />
                            <button
                              type="button"
                              className="delete-buttonctm"
                              onClick={() => handleDeleteButtonClick(image)}
                            >
                              <Iconify icon="gg:remove" style={{ marginBottom: '-5px' }} />
                            </button>
                          </div>
                        </div>
                      ) : null
                    )}
                  </div>
                </div>
              </Box>
            </Card>

            <Stack alignItems="inherit" sx={{ mt: 2 }}>
              <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                Save
              </LoadingButton>
            </Stack>
          </Grid>
        </Grid>
      </FormProvider>
      <div className="rejCancelEmptyBtn">
        <Grid container spacing={2} className="emptyRejbtn">
          <Grid xs={12} md={5}>
            <p className="pEmptyCls">empty</p>
          </Grid>

          <Grid xs={12} md={7} className="CancelBtnGrid">
            <Stack alignItems="inherit" sx={{ mt: 1 }}>
              <LoadingButton
                type="submit"
                variant="contained"
                className="CancelBtn"
                onClick={handleCancelClick}
              >
                Cancel Work Request
              </LoadingButton>
            </Stack>
          </Grid>
        </Grid>
      </div>
      <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogContent>
          <h4 className="DaiLgTitlH4">Are you sure you want to cancel the work request?</h4>
          <textarea
            value={textareaValue}
            onChange={(e) => setTextareaValue(e.target.value)}
            placeholder="Enter a reason for cancellation"
            rows={8}
            cols={70}
            className="customTextarea"
          />
          {errorMsg && <p className="errormessage">{errorMsg}</p>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmCancel} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

PendingStatus.propTypes = {
  selectedRowID: PropTypes.object,
  closeModalPending: PropTypes.object,
};
